import config  from '../lib/lib.config';
/**
 * Returns an event handler for newsletter selection, handling subscription logic based on user state.
 *
 * @param {string|number} id - The unique identifier of the newsletter.
 * @param {string} title - The title of the newsletter.
 * @param {boolean} isLogged - Indicates if the user is logged in.
 * @param {boolean} isPremium - Indicates if the user has a premium subscription.
 * @param {function} updateSubscriptions - Function to update user subscriptions.
 * @param {function} selectNewsletter - Function to select a newsletter for non-logged users.
 * @param {boolean} [isExclusive=false] - Whether the newsletter is exclusive to premium users.
 * @returns {function} Event handler function for newsletter selection.
 */
export function selectNewsletterHandlerClick(
  id,
  title,
  isLogged,
  isPremium,
  updateSubscriptions,
  selectNewsletter,
  isExclusive = false
) {
  return (e) => {
    if (isExclusive && !isPremium) {
      window.location.href = config.paywallRedirectUrl;
      return;
    }

    if (isLogged) {
      updateSubscriptions(e, {
        id,
      });
    } else {
      selectNewsletter({
        id,
        title: title,
      });
    }
  };
}
